import { ReactNode } from "react";
import { Symbols } from "./type";
import BigNumber from "bignumber.js";

const PiratesTreasurehUtils = {
  isBuyingFreeSpin(bombCount: number): boolean {
    return bombCount >= 4;
  },
  cleanSymbolId(symbol: number): { symbolId: number; featureId: number } {
    const mod = symbol % 100;
    if (mod > 90) {
      const realSymbolId = +Math.floor(symbol / 100).toFixed(0);
      // 9X suffix, it is no regular symbol, need special handle
      if (mod === 91) {
        return { symbolId: realSymbolId, featureId: 1 };
      } else {
        return { symbolId: realSymbolId, featureId: +(mod - 90).toFixed(0) };
      }
    }
    if (symbol > 10 && symbol < 100) {
      return {
        symbolId: +Math.floor(symbol / 10).toFixed(0),
        featureId: +(symbol % 10).toFixed(0),
      };
    }
    return {
      symbolId: symbol,
      featureId: NaN,
    };
  },
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  convertSymbol(symbol: number, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.Spades:
        return <img key={key} alt="High Pay 1" src="/pt/201.png" />;
      case Symbols.Hearts:
        return <img key={key} alt="High Pay 2" src="/pt/202.png" />;
      case Symbols.Clubs:
        return <img key={key} alt="High Pay 3" src="/pt/203.png" />;
      case Symbols.Diamonds:
        return <img key={key} alt="High Pay 4" src="/pt/204.png" />;
      case Symbols.Ace:
        return <img key={key} alt="Low Pay 1" src="/pt/101.png" />;
      case Symbols.King:
        return <img key={key} alt="Low Pay 2" src="/pt/102.png" />;
      case Symbols.Queen:
        return <img key={key} alt="Low Pay 3" src="/pt/103.png" />;
      case Symbols.Jack:
        return <img key={key} alt="Low Pay 4" src="/pt/104.png" />;

      case 0:
        return <></>;
      default:
        return symbol;
    }
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(50); // buy free spin rate
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.05) // bet size
      .multipliedBy(20) // 4*5 symbol count
      .multipliedBy(10) //  multiplier
      .multipliedBy(15); // symbol payout
  },
} as const;

export default PiratesTreasurehUtils;
